import { TransactionListConstants } from "../_constants";

export default function TransactionReducer(state = {}, action) {
  switch (action.type) {
    // tnx list data
    case TransactionListConstants.GET_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransactionListConstants.GET_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        getTransactionList: action?.user,
      };
    case TransactionListConstants.GET_TRANSACTION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case TransactionListConstants.GET_FIATCURRENCY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransactionListConstants.GET_FIATCURRENCY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        appFiatCurrencyList: action?.user?.data,
      };
    case TransactionListConstants.GET_FIATCURRENCY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //add coin
    case TransactionListConstants.CREATE_FIATCURRENCY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransactionListConstants.CREATE_FIATCURRENCY_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case TransactionListConstants.CREATE_FIATCURRENCY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //  update
    case TransactionListConstants.UPDATE_FIATCURRENCY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransactionListConstants.UPDATE_FIATCURRENCY_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case TransactionListConstants.UPDATE_FIATCURRENCY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //delete
    case TransactionListConstants.DELETE_FIATCURRENCY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransactionListConstants.DELETE_FIATCURRENCY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case TransactionListConstants.DELETE_FIATCURRENCY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //update status
    case TransactionListConstants.UPDATE_FIATCURRENCY_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TransactionListConstants.UPDATE_FIATCURRENCY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action?.user,
      };
    case TransactionListConstants.UPDATE_FIATCURRENCY_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case TransactionListConstants.GET_ORDERDEATILS_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case TransactionListConstants.GET_ORDERDEATILS_LIST_SUCCESS:
      return {
        ...state,
        getOrderList: action?.order?.data,
        loading: false,
      };
    case TransactionListConstants.GET_ORDERDEATILS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }

}